import { createApi } from '@reduxjs/toolkit/query/react'
import { authHeaderAPI } from 'redux/_helpers/auth-header'
import { baseQueryWithErrorHandler } from 'redux/_helpers/custom-base-query'

export const RoomsApi = createApi({
  reducerPath: 'RoomsAPI',
  baseQuery: baseQueryWithErrorHandler,
  tagTypes: ['Rooms'],
  endpoints: builder => ({
    addRoomApi: builder.mutation({
      query: ({ body, id }) => ({
        url: `/api/HotelRoom/${id}`,
        method: 'POST',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['Rooms'],
    }),
    editRoom: builder.mutation({
      query: ({ body, id }) => ({
        url: `/api/HotelRoom/${id}`,
        method: 'PUT',
        body,
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['Rooms'],
    }),
    getRoomsTypes: builder.query({
      query: id => ({
        url: `/api/Hotel/GetHotelRoomTypes`,
        method: 'POST',
        params: { hotelId: id },
        headers: authHeaderAPI(),
      }),
      providesTags: ['Rooms'],
    }),
    getHotelRoomsById: builder.query({
      query: id => ({
        url: `/api/HotelRoom/${id}`,
        method: 'GET',
        headers: authHeaderAPI(),
      }),
      providesTags: ['Rooms'],
    }),
    delteRoomPhoto: builder.mutation({
      query: path => ({
        url: `/api/HotelRoom/DeleteRoomPhoto?photoPath=${path}`,
        method: 'DELETE',
        headers: authHeaderAPI(),
      }),
      invalidatesTags: ['Rooms'],
    }),
  }),
})

export const {
  useAddRoomApiMutation,
  useGetRoomsTypesQuery,
  useGetHotelRoomsByIdQuery,
  useDelteRoomPhotoMutation,
  useEditRoomMutation,
} = RoomsApi
